module.exports = __webpack_public_path__ + "static/media/angels-icon.7193e636.png";